// extracted by mini-css-extract-plugin
export default {"main":"minesweeper_main__ACiT7","wrapper":"minesweeper_wrapper__K71xw"};